import vodAdApi from "./vodAdApi";
import timerManager from "@comp/platformApi/timerManager";
import consoleApi from "@comp/platformApi/consoleApi";

const config = {
    adTimeDeviation : 1
};

// 需要：视频播放控制器
export default {

    parent : null,

    // running | stop
    status : 'stop',

    /**
     * structure: adFileId, coverImg, showTime
     */
    adList : [],

    // 是否已开始播放
    videoPlayStatus : false,

    videoCurrentTime : 0,

    timer : null,

    currentPlayingAd : null,

    /**
     * @param   {Object}    options
     * @param   {Number}    options.bizId
     * @param   {Number}    options.bizType
     */
    init(options) {

        this.parent = options.parent || null;

        vodAdApi.getVideoAd({
            bizId : options.bizId,
            bizType : options.bizType,
        }, (result) => {
            let list = result;

            // 添加额外的控制字段
            for (let i=0; i<list.length; i++)
            {
                // played | ''
                list[i].status = '';    // 标记是否已观看
            }
            this.adList = result;
            consoleApi.log('视频广告数据：');
            consoleApi.table(result);
        });

    },

    updateTime(seconds) {
        this.videoCurrentTime = seconds;
    },

    endAd() {
        this.currentPlayingAd.status = 'played';
        this.currentPlayingAd = null;

        consoleApi.log('视频广告数据：');
        consoleApi.table(this.adList);
    },

    startUp(parent) {

        if (this.status != 'stop')
        {
            return;
        }

        // 循环检查当前播放时间，匹配是否有需要播放的广告
        const me = this;
        this.timer = timerManager.setInterval(() => {

            // 未开始播放，忽略
            if (!me.videoPlayStatus)
            {
                return;
            }

            // 没数据则忽略，没有控制器则忽略，已经播放中则忽略
            if (me.adList.length < 1 || me.currentPlayingAd)
            {
                return;
            }

            consoleApi.log('check video ad.');
            let seconds = this.videoCurrentTime;
            consoleApi.log('seconds: ' + seconds);

            for (let i=0; i<me.adList.length; i++)
            {
                if (me.adList[i].status == 'played')
                {
                    continue;
                }

                // 正负时间误差范围内触发
                if (seconds >= me.adList[i].showTime - config.adTimeDeviation &&
                    seconds <= me.adList[i].showTime + config.adTimeDeviation)
                {
                    consoleApi.log('play video ad.');
                    this.currentPlayingAd = me.adList[i];
                    this.outputSignal({
                        type : 'playAd',
                        data : me.adList[i]
                    });
                    return;
                }
            }

        },2000);
    },

    stop() {
        if (this.status != 'running')
        {
            return;
        }

        timerManager.clearInterval(this.timer);
        this.timer = null;
    },

    outputSignal(signal) {
        if (!this.parent || typeof (this.parent.inputSignal) === 'undefined')
        {
            return;
        }

        this.parent.inputSignal(signal);
    }

}
